import confetti from "canvas-confetti"
import { randomInRange } from "@/lib/utils"
export const DEFAULT_CONFIG = {
  colors: ["#4EBAC7", "#F8BC4D", "#FF97C8"],
  zIndex: -1,
  angle: 90,
  spread: 180,
  particleCount: 150,
  startVelocity: 45,
  gravity: 0.5,
  scalar: 1.8,
  ticks: 450,
  origin: { y: 0.3 },
}

export const CUSTOM_CONFIG = {
  colors: ["#4EBAC7", "#F8BC4D", "#FF97C8"],
  zIndex: 51,
  spread: 360,
  particleCount: 150,
  ticks: 300,
  gravity: 0.7,
  decay: 0.96,
  startVelocity: 20,
  shapes: ["square", "square", "circle", "circle", "star"],
  scalar: 1.8,
  origin: { x: randomInRange(30, 70) / 100, y: randomInRange(30, 70) / 100 },
}

export function useConfetti() {
  const launchConfetti = (config = DEFAULT_CONFIG) => {
    confetti(config)
  }

  return {
    launchConfetti,
  }
}
